export enum DfMetaDataKeyEnum {
  USER_SCOPES = 'USER_SCOPES',
  DANCE_MANAGER_ROLES_SCOPES = 'DANCE_MANAGER_ROLES_SCOPES',
  DANCE_MANAGER_FEATURE_SCOPES = 'DANCE_MANAGER_FEATURE_SCOPES',
}
